/* eslint-disable @typescript-eslint/no-explicit-any */

import { RootState } from '@/store/interfaces/rootState';
import { ActionTree, GetterTree, MutationTree } from 'vuex';
import { configHostURL } from '@/const/companyHost';
import i18n from '@/i18n';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { allowAny } from '@parra-payments/components';
import { ConfigurationState, iCompanyConfiguration, ihostConfig } from '../interfaces/configurations';
import configurations from '../types/configurations';
import hostConfig from '@/config/index.json';

const namespaced = true;

const state: ConfigurationState = {
  hostConfig,
};

const getters: GetterTree<ConfigurationState, RootState> = {
  [configurations.getters.GET_HOST_CONFIGURATION]: state => {
    return state.hostConfig;
  },
};
const mutations: MutationTree<ConfigurationState> = {
  [configurations.mutations.SET_I18N_LOCAL_MESSAGE]: (_state, response: { data: iCompanyConfiguration }) => {
    const commerceTranslation = response.data.translations.commerce;
    const companyTranslation = response.data.translations.company;
    const transactionTranslation = response.data.translations.transactions;
    const nemiPayCompany = i18n.messages.nemiPay as allowAny;

    const translations = {
      commerce: {
        plural: {
          formal: commerceTranslation.plural,
          informal: commerceTranslation.plural.toLowerCase(),
        },
        singular: {
          formal: commerceTranslation.singular,
          informal: commerceTranslation.singular.toLowerCase(),
        },
      },
      company: {
        plural: {
          formal: companyTranslation.plural,
          informal: companyTranslation.plural.toLowerCase(),
        },
        singular: {
          formal: companyTranslation.singular,
          informal: companyTranslation.singular.toLowerCase(),
        },
      },
      transactions: {
        plural: {
          formal: transactionTranslation.plural,
          informal: transactionTranslation.plural.toLowerCase(),
        },
        singular: {
          formal: transactionTranslation.singular,
          informal: transactionTranslation.singular.toLowerCase(),
        },
      },
    };

    const newMessages = {
      nemiPay: {
        menu: { ...nemiPayCompany.menu, },
        commerce: { ...nemiPayCompany.commerce, },
        company: { ...nemiPayCompany.company, },
      },
      [i18n.locale]: {
        menu: translations,
        commerce: { ...nemiPayCompany.commerce, },
        company: { ...nemiPayCompany.company, },
      },
    };

    i18n.setLocaleMessage(i18n.locale, { ...newMessages[i18n.locale], });

    window.localStorage.setItem('translations', JSON.stringify(i18n.messages));
  },
  [configurations.mutations.SET_HOST_CONFIGURATION]: (state, config: ihostConfig) => {
    state.hostConfig = {
      ...hostConfig,
      globals: {
        ...hostConfig.globals,
        ...config.globals,
      },
      commerce: {
        ...hostConfig.commerce,
        ...config.commerce,
      },
      companies: {
        ...hostConfig.companies,
        ...config.companies,
      },
      commissions: {
        ...hostConfig.commissions,
        ...config.commissions,
      },
      company_users: {
        ...hostConfig.company_users,
        ...config.company_users,
      },
    };
  },
};
const actions: ActionTree<ConfigurationState, RootState> = {
  [configurations.actions.HOST_CONFIGURATION]: ({ commit, }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(configHostURL)
        .then((res: AxiosResponse<ihostConfig>) => {
          commit(configurations.mutations.SET_HOST_CONFIGURATION, res.data);
          resolve(res);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
